<!-- <h1>File component</h1> -->
<!-- <div class="content-module">
  <div class="content-leyenda">
    <div *ngFor="let f of fileDescription">
      <div class="file-card">
        <div class="card-file">
          <div class="card-header-file">
            <div class="card-icon-file">
              <mat-icon> menu </mat-icon>
            </div>
            {{ f.description }}
          </div>

        </div>

      </div>
    </div>
  </div>

</div> -->
<router-outlet ></router-outlet>
